import { render, staticRenderFns } from "./card-travel.vue?vue&type=template&id=d88b29bc&scoped=true"
import script from "./card-travel.vue?vue&type=script&lang=js"
export * from "./card-travel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88b29bc",
  null
  
)

export default component.exports